export const FETCH_CREATE_ACTIVITY_DATA = "FETCH_CREATE_ACTIVITY_DATA";
export const FETCH_EDIT_ACTIVITY_DATA = "FETCH_EDIT_ACTIVITY_DATA";
export const FETCH_CLONE_ACTIVITY_DATA = "FETCH_CLONE_ACTIVITY_DATA";
export const FETCH_CREATE_ACTIVITY_DATA_SUCCESS = "FETCH_CREATE_ACTIVITY_DATA_SUCCESS";
export const FETCH_SKILLSET_TAGS = "FETCH_SKILLSET_TAGS";
export const FETCH_SKILLSET_TAGS_SUCCESS = "FETCH_SKILLSET_TAGS_SUCCESS";
export const FETCH_PROPERTY_LOCATION = "FETCH_PROPERTY_LOCATION";
export const FETCH_PROPERTY_LOCATION_SUCCESS = "FETCH_PROPERTY_LOCATION_SUCCESS";
export const REMOVE_PROPERTY_LOCATION = "REMOVE_PROPERTY_LOCATION";
export const CREATE_ACTIVITY_REQUEST = "CREATE_ACTIVITY_REQUEST";
export const UPDATE_ACTIVITY_REQUEST = "UPDATE_ACTIVITY_REQUEST";
export const ON_CLOSE_ACTIVITY = "ON_CLOSE_ACTIVITY";
export const REMOVE_ASSIGNMENT_METHOD_LIST = "REMOVE_ASSIGNMENT_METHOD_LIST";
export const FETCH_PROPERTY_STATES_REQUEST ="FETCH_PROPERTY_STATES_REQUEST";
export const FETCH_PROPERTY_STATES_SUCCESS ="FETCH_PROPERTY_STATES_SUCCESS";
export const FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST="FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST";
export const FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST_SUCCESS="FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST_SUCCESS";
export const FETCH_ASSIGNMENTMETHOD_B2BLIST="FETCH_ASSIGNMENTMETHOD_B2BLIST";
export const FETCH_ASSIGNMENTMETHOD_B2BLIST_SUCCESS="FETCH_ASSIGNMENTMETHOD_B2BLIST_SUCCESS";
export const FETCH_ASSIGNMENTMETHOD_CONTRACTLIST="FETCH_ASSIGNMENTMETHOD_CONTRACTLIST";
export const FETCH_ASSIGNMENTMETHOD_CONTRACTLIST_SUCCESS="FETCH_ASSIGNMENTMETHOD_CONTRACTLIST_SUCCESS";


